import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { PageContentBox, AppPageContentWrapper } from "@duosoftbg/nacid-components";
import ARUniEntryRequestView from "../../../../components/registers/request/arUni/ARUniEntryRequestView";

const ARUniEntryRequestViewPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest.view")}>
      <AppPageContentWrapper>
        <PageContentBox>
          <ARUniEntryRequestView />
        </PageContentBox>
      </AppPageContentWrapper>
    </PageWrapper>
  );
};
export default ARUniEntryRequestViewPage;
